import { render } from "./MainCustomers.vue?vue&type=template&id=51806d4e&scoped=true"
import script from "./MainCustomers.vue?vue&type=script&lang=js"
export * from "./MainCustomers.vue?vue&type=script&lang=js"

import "./MainCustomers.vue?vue&type=style&index=0&id=51806d4e&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51806d4e"]])

export default __exports__